import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CardSekeleton = () => {
  return (
      <Skeleton height={100} />
  );
};

export default CardSekeleton;
